import { Typography } from '@mui/material';
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import type { RegistryAllocation } from '../../api/registryEntityTypes';
import { ENTITY_TYPE_LABELS, formatAmount } from '../../entities/entityFormat';
import { entityPath } from '../../entities/entityPaths';
import type { Column } from '../../ui/DataTable';

const INVESTOR_STATUS_LABELS: Record<string, string> = {
  CANDIDATE: 'Candidate',
  LEAD: 'Lead',
  OPPORTUNITY: 'Opportunity',
  COMMITTED_INVESTOR: 'Committed',
};

/** The context column: the fund opportunity on an entity's page, the entity on a fund's. */
export function contextColumn(groupBy: 'entity' | 'fundOpportunity'): Column<RegistryAllocation> {
  if (groupBy === 'fundOpportunity')
    return {
      key: 'context',
      label: 'Fund opportunity',
      sortValue: (row) => row.fundOpportunity.name,
      render: (row) => row.fundOpportunity.name,
    };
  return {
    key: 'context',
    label: 'Investment entity',
    sortValue: (row) => row.investmentEntityName,
    render: (row) => (
      <>
        <RouterLink to={entityPath(row.investmentEntityExternalId)}>
          {row.investmentEntityName}
        </RouterLink>
        <Typography variant="caption" color="text.secondary" component="div">
          {ENTITY_TYPE_LABELS[row.investmentEntityType]}
        </Typography>
      </>
    ),
  };
}

export const INVESTOR_COLUMN: Column<RegistryAllocation> = {
  key: 'investor',
  label: 'Investor',
  sortValue: (row) => row.contact.name,
  render: (row) => (
    <>
      {row.contact.name}
      <Typography variant="caption" color="text.secondary" component="div">
        {INVESTOR_STATUS_LABELS[row.investorStatus] ?? row.investorStatus}
      </Typography>
    </>
  ),
};

export const AMOUNT_COLUMN: Column<RegistryAllocation> = {
  key: 'amount',
  label: 'Allocated',
  align: 'right',
  render: (row) => formatAmount(row.allocatedAmount),
};
